import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

// Keep compact provider credit on every map with expandable full sources.
const credits = '<a href="https://leafletjs.com" target="_blank" rel="noopener noreferrer">Leaflet</a> | Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community';

export default function MapCredits() {
  const map = useMap();
  useEffect(() => {
    const control = new L.Control({ position: 'bottomright' });
    let container: HTMLDivElement;
    const dismissOutside = (event: PointerEvent) => {
      if (container && !container.contains(event.target as Node)) container.querySelector('details')?.removeAttribute('open');
    };
    control.onAdd = () => {
      container = L.DomUtil.create('div', 'map-credits');
      container.innerHTML = `<details class="map-credits-disclosure"><summary aria-label="Map credits">&copy; Esri</summary><div class="map-credits-sources"><div class="map-credits-heading"><strong>Map credits</strong><button type="button" aria-label="Close map credits">&times;</button></div>${credits}</div></details>`;
      container.querySelector('button')?.addEventListener('click', () => {
        container.querySelector('details')?.removeAttribute('open');
        container.querySelector('summary')?.focus();
      });
      L.DomEvent.disableClickPropagation(container);
      L.DomEvent.disableScrollPropagation(container);
      container.addEventListener('keydown', event => {
        event.stopPropagation();
        if (event.key === 'Escape') {
          container.querySelector('details')?.removeAttribute('open');
          container.querySelector('summary')?.focus();
        }
      });
      return container;
    };
    control.addTo(map);
    document.addEventListener('pointerdown', dismissOutside, true);
    return () => { document.removeEventListener('pointerdown', dismissOutside, true); control.remove(); };
  }, [map]);
  return null;
}
